<template>
  <div v-if="demandes">
    <v-form
      lazy-validation
      ref="formDepotPiece"
      v-model="validFormDepotPiece"
      @submit.prevent
      vv-if="
        demandes.length == 0 || demandes[demandes.length - 1].validation != null
      "
    >
      <!-- <v-file-input
      label="Nouveau document DepotPiece"
      :rules="[
        (value) => !!value || 'Champ requis.',
        (value) =>
          (!!value &&
            /^.+\.(pdf|png|jpg|jpeg)$/.test(value[0].name.toLowerCase())) ||
          'Format incorrect. Formats acceptés : pdf, png, jpg, jpeg.',
      ]"
      accept=".pdf, .png, .jpg, .jpeg"
      multiple
      v-model="DepotPiece.nameFile"
    >
    <template v-slot:selection="{ text }">
      <v-chip
        small
        label
        color="primary"
      >
        {{ text }}

      </v-chip>
    </template>
    </v-file-input> -->
      <v-container fluid>
        <v-row>
          <v-col cols="2" class="d-flex" align-self="center">
            Choisissez votre rubrique :
          </v-col>
          <v-col cols="4" class="d-flex">
            <v-select
              :items="libelles"
              label="Libelle"
              v-model="DepotPiece.libelle"
              single-line
              clearable
              required
              :rules="[(value) => !!value || 'Champ requis.']"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-col cols="2"> Ajouter votre ou vos fichier(s) : </v-col>
      <v-row v-for="index in nbDocs" :key="index">
        <v-col sm="4">
          <v-file-input
            label="Nouveau document DepotPiece"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (value) =>
                (!!value &&
                  /^.+\.(pdf|png|jpg|jpeg)$/.test(value.name.toLowerCase())) ||
                'Format incorrect. Formats acceptés : pdf, png, jpg, jpeg.',
            ]"
            accept=".pdf, .png, .jpg, .jpeg"
            v-model="DepotPiece.nameFile[index]"
            required
          >
            <template v-slot:selection="{ text }">
              <v-chip small label color="primary">
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>
          <!-- {{i.name}} : <v-chip small color="error"><v-btn icon @click="spliceFiles(i)"><v-icon>close</v-icon></v-btn></v-chip> -->
          <!-- <v-select
        :items="types"
        v-model="i.code"
      ></v-select> -->
          <!-- <div v-if="DepotPiece.nameFile[index]">
          {{ index.name }} :
          <v-chip small color="error"
            ><v-btn icon @click="spliceFiles(index)"
              ><v-icon>close</v-icon></v-btn
            ></v-chip
          >
          <v-select
            :items="types"
            v-model="DepotPiece.nameFile[index].code"
          ></v-select>
        </div> -->
        </v-col>
        <v-col v-if="index > 1" sm="4"
          ><v-btn
            @click="
              DepotPiece.nameFile.splice(index, 1);
              nbDocs -= 1;
            "
            icon
            ><v-icon>delete</v-icon></v-btn
          ></v-col
        >
      </v-row>
      <v-btn color="success" @click="nbDocs += 1" icon
        ><v-icon>add</v-icon></v-btn
      >
      <v-btn color="error" @click="removeDoc" icon
        ><v-icon>remove</v-icon></v-btn
      >
      <br /><br />
      <v-btn
        class="mx-2"
        :disabled="!validFormDepotPiece"
        color="success"
        @click="validerFormDepotPiece"
        ><v-icon left>mdi-magnify</v-icon>Valider</v-btn
      >
    </v-form>

    <v-data-table v-if="demandes" :headers="headers" :items="demandes">
      <template v-slot:[`item.validation`]="{ item }">
        <v-chip v-if="item.validation == null" color="warning">
          en cours
        </v-chip>
        <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
        <v-chip v-else-if="item.validation == 1" color="success"
          >accepté</v-chip
        >
      </template>
      <template v-slot:[`item.createAt`]="{ item }">
        <v-col>{{
          item.createAt
            ? new Date(item.createAt).toLocaleString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : ""
        }}</v-col>
      </template>
      <template v-slot:[`item.nameFile`]="{ item }">
        <v-btn icon color="grey" @click="afficherPDF(item)"
          ><v-icon>mdi-book-open-variant</v-icon></v-btn
        >
      </template>
      <template v-slot:[`item.messagerie`]="{ item }">
        <v-col>
          <v-badge
            :color="
              item.nombreMessagesUtilisateur <= 0 ? 'transparent' : 'primary'
            "
            :content="item.nombreMessagesUtilisateur"
          >
            <v-btn
              icon
              @click="lancerMessagerie(item)"
              :color="item.nombreMessagesUtilisateur > 0 ? 'red' : 'grey'"
              ><v-icon>chat</v-icon></v-btn
            >
          </v-badge>
        </v-col>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogPDF"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <BaseBlock>
        <v-row align="center" justify="center">
          <v-btn
            @click="documentLeft"
            color="success"
            icon
            :disabled="temoin == 0"
            ><v-icon x-large>chevron_left</v-icon></v-btn
          >
          <!-- <v-col align="center" justify="center" v-if="affichagePDF"> -->
          <v-responsive height="500px" width="100px">
            <iframe
              height="100%"
              width="100%"
              :src="iframeSrc"
              title="document pdf"
              style="background: #ffffff"
            ></iframe>
          </v-responsive>
          <v-btn
            color="success"
            icon
            @click="documentRight"
            :disabled="temoin >= nombreDocuments - 1"
            ><v-icon x-large>chevron_right</v-icon></v-btn
          >
        </v-row>

        <v-row justify="center">
          <v-btn
            color="error"
            @click="
              dialogPDF = false;
              iframeSrc = null;
              nombreDocuments = -1;
              document = null;
            "
            >fermer</v-btn
          >
        </v-row>
      </BaseBlock>
    </v-dialog>
    <messagerie ref="messagerie" :temoinGestionnaire="false"></messagerie>
  </div>
</template>

<script>
import ApiDepotPieceRepository from "@/repositories/ApiDepotPieceRepository";
import messagerie from "@/components/Messagerie";
import BaseBlock from "@/components/base/BaseBlock";

export default {
  components: {
    messagerie,
    BaseBlock,
  },
  data() {
    return {
      nbDocs: 1,
      libelles: [],
      validFormDepotPiece: false,
      demandes: [],
      demande: null,
      DepotPiece: {
        type: "",
        nameFile: [],
        libelle: null,
        validation: null,
      },
      DepotPieceEmpty: {
        type: "",
        nameFile: [],
        libelle: null,
        validation: null,
      },
      affichagePDF: true,
      temoin: 0,
      nombreDocuments: -1,
      iframeSrc: "",
      dialogPDF: false,
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Date de création",
          value: "createAt",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Nom du fichier",
          value: "nameFile",
        },
        {
          text: "Statut",
          value: "validation",
        },
        {
          text: "Libelle",
          value: "libelle",
        },
        {
          text: "Messagerie",
          value: "messagerie",
        },
        {
          text: "Message de refus",
          value: "messageRefus",
        },
      ],
    };
  },
  async created() {
    if (this.$route.path == "/situationfamiliale") {
      this.demandes = await ApiDepotPieceRepository.getDemandesByType(
        "SituationFamiliale"
      );
      this.DepotPiece.type = "SituationFamiliale";
      this.libelles = [
        "Acte de mariage",
        "Jugement de divorce",
        "PACS",
        "Attestation de rupture PACS",
        "Extrait acte de Naissance",
        "Extrait d’adoption",
      ];
    } else if (this.$route.path == "/etatcivil") {
      this.demandes = await ApiDepotPieceRepository.getDemandesByType(
        "etatcivil"
      );
      this.DepotPiece.type = "etatcivil";
      this.libelles = [
        "Déclaration de changement d’identité (carte d'identité, passeport...)",
        "Immatriculation sociale",
        "Titre de séjour en cours de validité",
      ];
    }
    this.demandes = this.demandes.reverse();
  },
  watch: {
    "DepotPiece.nameFile": function () {
      console.log(this.DepotPiece.nameFile);
      return this.DepotPiece;
    },
    $route: async function () {
      if (this.$route.path == "/situationfamiliale") {
        this.demandes = await ApiDepotPieceRepository.getDemandesByType(
          "SituationFamiliale"
        );
        this.DepotPiece.type = "SituationFamiliale";
        this.libelles = [
          "Acte de mariage",
          "Jugement de divorce",
          "PACS",
          "Attestation de rupture PACS",
          "Extrait acte de Naissance",
          "Extrait d’adoption",
        ];
      } else if (this.$route.path == "/etatcivil") {
        this.demandes = await ApiDepotPieceRepository.getDemandesByType(
          "etatcivil"
        );
        this.DepotPiece.type = "etatcivil";
        this.libelles = [
          "Déclaration de changement d’identité (carte d'identité, passeport...)",
          "Immatriculation sociale",
          "Titre de séjour en cours de validité",
        ];
      }
      this.$refs.formDepotPiece.reset();
    },
  },
  methods: {
    validerFormDepotPiece() {
      if (this.$refs.formDepotPiece.validate()) {
        this.$confirm(
          "<strong>ATTENTION, en validant ce dossier vous ne pourrez plus le modifier. " +
            "Cliquez sur 'Oui' pour confirmer votre demande ou sur 'Non' pour revenir à l'écran précédent.</strong>"
        ).then(async (response) => {
          if (response) {
            // console.log(this.DepotPiece);
            this.demandes.unshift(
              await ApiDepotPieceRepository.saveDepotPiece(this.DepotPiece)
            );
            // this.demandes[0].createAt = this.formatOneDate(
            //   this.demandes[0].createAt
            // );
            this.DepotPiece = Object.assign({}, this.DepotPieceEmpty);
            if (this.$route.path == "/situationfamiliale") {
              this.DepotPiece.type = "SituationFamiliale";
            } else if (this.$route.path == "/etatcivil") {
              this.DepotPiece.type = "etatcivil";
            }
            this.$refs.formDepotPiece.reset();
            this.nbDocs = 1;
          }
        });
      }
    },
    spliceFiles(item) {
      console.log(item);
      var index = this.DepotPiece.nameFile.indexOf(item);
      console.log(index);
      this.DepotPiece.nameFile.splice(index, 1);
    },
    removeDoc() {
      if (this.nbDocs > 1) {
        this.nbDocs -= 1;
      }
    },
    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      item.nombreMessagesUtilisateur = 0;
    },
    async documentRight() {
      this.temoin += 1;
      this.iframeSrc = "";
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileAgent(
        this.demande.id,
        this.temoin
      );
    },

    async documentLeft() {
      this.temoin -= 1;
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileAgent(
        this.demande.id,
        this.temoin
      );
    },

    async afficherPDF(item) {
      this.demande = item;
      this.nombreDocuments = item.nombreDocuments;
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileAgent(
        item.id,
        this.temoin
      );

      this.dialogPDF = true;
    },
  },
};
</script>
